import { Dispatch, SetStateAction } from 'react'
import { Popover, Tooltip } from '@opallabs/lapidary'
import { useGetReactions } from '../queries/useGetReactions'
import { EmojiPopoverContent, Emoji } from './EmojiPopoverContent'

export type EmojiPopoverProps = {
  isReaction?: boolean
  openPopover: boolean
  setOpenPopover: Dispatch<SetStateAction<boolean>>
  onSelect: (emoji: Emoji) => void
}

export const EmojiPopover: React.FC<
  React.PropsWithChildren<EmojiPopoverProps>
> = ({ isReaction, openPopover, onSelect, children, setOpenPopover }) => {
  const { data } = useGetReactions()

  if (openPopover)
    return (
      <Popover.Root defaultOpen={true} onOpenChange={setOpenPopover}>
        <Popover.Trigger>{children}</Popover.Trigger>
        <Popover.Content
          zIndex={9999}
          side="top"
          showArrow={true}
          onEscapeKeyDown={(e) => e.stopPropagation()}
        >
          {data && <EmojiPopoverContent emojis={data} onSelect={onSelect} />}
        </Popover.Content>
      </Popover.Root>
    )

  return (
    <Tooltip
      content={isReaction ? 'Add Reaction' : 'Add Emoji'}
      legacyTheme={isReaction ? 'light' : 'dark'}
      zIndex={9999}
    >
      {children}
    </Tooltip>
  )
}
